import * as React from 'react';
import { useFormik, FormikValues } from 'formik';
import { Validators } from 'core';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import Button from 'components/molecules/button';
import Input from 'components/organisms/input';
import { AuthSelectors } from 'common/config/store';
import { useIntl } from 'common/config/i18n';
import FormError from 'components/molecules/form-error';
import {
  StyledFormWrapper as WrapperForm,
  StyledFormBottomWrapper as ForgotPasswordWrapper,
} from 'common/styling/mixins';

interface FormValues {
  email?: string;
}
interface OtherProps {
  title?: string;
  onSubmit: (values: FormikValues) => void;
  status?: 'loading' | 'error' | 'success';
}

const Form = (props: FormValues & OtherProps) => {
  const { t } = useIntl();
  const formik = useFormik({
    initialValues: {
      email: props.email || '',
    },
    validate: (values) => Validators.forgotPassword(values),
    onSubmit: (values) => {
      props.onSubmit(values);
    },
  });
  const error = useSelector(AuthSelectors.errorSelector);

  return (
    <form onSubmit={formik.handleSubmit}>
      <WrapperForm>
        <Input
          width="270px"
          upLabel={t('form', 'FORM_EMAIL')}
          type="email"
          name="email"
          onChange={formik.handleChange}
          value={formik.values.email}
        />
        <FormError formik={formik} fieldName="email" />
      </WrapperForm>
      {error === 'CLIENT_ERROR' && <FormError message={t('form', 'FORM_FORGOT_PASSWORD_ERROR')} />}
      <Button
        height="50px"
        width="100%"
        borderRadius="20px"
        disabled={!!(formik.errors.email && formik.touched.email)}
        loading={props.status === 'loading'}
        htmlType="submit"
      >
        {t('Buttons', 'RESET_BUTTON')}
      </Button>

      <ForgotPasswordWrapper>
        <Link to="/login">{t('form', 'FORM_CONNECT_LINK')}</Link>
      </ForgotPasswordWrapper>
    </form>
  );
};
export default Form;
